import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=08901082&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08901082')) {
      api.createRecord('08901082', component.options)
    } else {
      api.reload('08901082', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=08901082&", function () {
      api.rerender('08901082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/practice-info/Contacts.vue"
export default component.exports